class MultiChildError extends Error {
  constructor(message, errors) {
    super(message);
    Object.setPrototypeOf(this, MultiChildError.prototype);
    this.errors = errors;
  }

  errorMessages() {
    let m = {};

    for (const e of Object.entries(this.errors)) {
      m[e[0]] = e[1].message;
    }

    return m;
  }
}

export { MultiChildError };



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/utils/errors.js